import { useFeatureFlag } from "@/Hooks/useFeature";

export const useMultiCurrencyEnabled = (): boolean =>
	useFeatureFlag("multi_currency_v1");
